<template>
  <v-dialog
    v-model="isActive"
    max-width="600"
    @click:outside="cancel"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar color="blue-grey-darken-2">
        <v-card-title class="text-h5">{{ headlineLocalized }}</v-card-title>
      </v-toolbar>
      <v-card-text class="pt-5">
        {{ contentTextLocalized }}
      </v-card-text>
      <v-file-input
          class="mr-15 ml-15"
          v-model="file"
          counter
          accept="text/csv"
          :label="$t('SelectFileDialog.fileInputLabel')"
          :placeholder="$t('SelectFileDialog.fileInputLabel')"
          prepend-inner-icon="mdi-file-import"
          variant="outlined"
          :show-size="1000"
      >
        <template v-slot:selection="{ index, text }">
          <v-chip
              v-if="index < 1"
              size="small"
              label
          >
            {{ text }}
          </v-chip>
        </template>
      </v-file-input>
      <v-card-actions>
        <v-spacer />
        <BaseButton
            :buttonText="buttonCancelLocalized"
            @click="cancel"
        />
        <BaseButton
            :buttonText="buttonConfirmLocalized"
            :isDisabled="!file"
            @click="confirm"
        />
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">

import { ref, computed } from 'vue';
import BaseButton from "@/components/buttons/BaseButton.vue";
import { useI18n } from "@/composables/useI18n";

const {
  t
} = useI18n();

const props = defineProps({
  headline: {
    type: String,
    required: false,
    default: ""
  },
  contentText: {
    type: String,
    required: false,
    default: ""
  },
  buttonConfirm: {
    type: String,
    required: false,
    default: ""
  },
  buttonCancel: {
    type: String,
    required: false,
    default: ""
  }
});

const headlineLocalized = computed(() => props.headline || t("SelectFileDialog.headline"));
const contentTextLocalized = computed(() => props.contentText || t("SelectFileDialog.contentText"));
const buttonConfirmLocalized = computed(() => props.buttonConfirm || t("SelectFileDialog.buttonConfirm"));
const buttonCancelLocalized = computed(() => props.buttonCancel || t("SelectFileDialog.buttonCancel"));

const isActive = ref(false);
const file = ref<File>();

const show = () => {
  file.value = undefined; // reset state
  isActive.value = true;
};

const hide = () => {
  isActive.value = false;
};

const cancel = () => {
  hide();
  emit("onDialogCancel");
};

const confirm = () => {
  hide();
  emit("onDialogConfirm", file.value);
};

const emit = defineEmits(["onDialogCancel", "onDialogConfirm"]);

defineExpose({
  show
})

</script>

